<script>
export default {
  methods: {
    formatCurrency: function(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2
      });
      return formatter.format(parseFloat(amount));
    }
  }
};
</script>
